import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("", {"contents":"","moduleName":"later/components/global-search/recent-searches.hbs","parseOptions":{"srcName":"later/components/global-search/recent-searches.hbs"}});
import templateOnly from '@ember/component/template-only';

export default templateOnly();
